import { useState, useEffect } from 'react';
import {
  Button, Link, Grid2 as Grid, Typography, IconButton
} from '@mui/material';
import PinInput from 'react-pin-input';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import PropTypes from 'prop-types';

import { checkCode } from '../../actions/users';

const FormForgetPass3 = ({
  setCodigo, setPasos, type, data, codigo
}) => {
  const [disableSMS, setDisableSMS] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setDisableBtn(codigo.length !== 4);
  }, [codigo]);

  const reenviar = () => {
    setDisableSMS(true);
    setTimeout(() => {
      setDisableSMS(false)
    }, 18000);
  }

  const recuperar = async e => {
    e.preventDefault();
    if (codigo.length !== 4) {
      return setError("Deben de ser 4 dígitos");
    }
    if (type === "celular") {
      const to = "52".concat(data.tel);
      const info = {
        phonenumber: to,
        code: codigo,
      }
      setDisableBtn(true);
      const resCode = await checkCode(info);
      if (resCode) {
        setPasos(4);
      } else {
        setError("Código incorrecto");
      }
    } else {
      // Verificación EMAIL (Ahora valida en el servidor también)
      const info = {
        email: data.email,
        code: codigo,
      }
      setDisableBtn(true);
      const resCode = await checkCode(info);
      console.log("resCode: ", resCode)
      if (!resCode.error) {
        setPasos(4);
      } else {
        setError(resCode.msg);
        setDisableBtn(false);
      }
    }
  }

  return (
    <form noValidate onSubmit={recuperar}>
      <Grid item xs={12}>
        <IconButton
          className="btn-icon"
          aria-label="back"
          onClick={() => setPasos(2)}
        >
          <ChevronLeftIcon />
        </IconButton>
      </Grid>
      <Grid container sx={{ my: 2 }} spacing={{ sx: 1 }}>
        <Grid className="step1" container direction="column">
          <Typography variant="h3" component="h3">¿Olvidaste tu contraseña?</Typography>
          <Typography component="p">Introduce el código recibido.</Typography>
        </Grid>
        <Grid size={12}>
          <PinInput
            length={4}
            onChange={(value) => setCodigo(value)}
            inputStyle={error ? { borderColor: 'red' } : {}}
          />
          {error && (
            <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
              {error}
            </Typography>
          )}
        </Grid>
      </Grid>
      <Grid size={{ xs: 8, lg: 6 }} sx={{ mt: 3 }}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          type="submit"
          disabled={disableBtn}
        >
          Continuar
        </Button>
      </Grid>
      <Grid container>
        <Grid size={12} sx={{ mt: 3 }}>
          <Typography className="link" component="p">
            <Link
              component="button"
              underline="hover"
              disabled={disableSMS}
              onClick={() => reenviar()}
            >
              No recibí el código, enviar de nuevo
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </form>
  )
}

FormForgetPass3.propTypes = {
  setPasos: PropTypes.func.isRequired,
  codigo: PropTypes.any.isRequired,
  setCodigo: PropTypes.func.isRequired,
}

export default FormForgetPass3;
